/// <amd-module name="SuiteCommerce.GiftCertificate.Common.InstrumentationHelper"/>
define("SuiteCommerce.GiftCertificate.Common.InstrumentationHelper", ["require", "exports", "SuiteCommerce.GiftCertificate.Instrumentation", "SuiteCommerce.GiftCertificate.OptionTiles.Configuration", "SuiteCommerce.GiftCertificate.Main.Configuration"], function (require, exports, Instrumentation_1, OptionTiles_Configuration_1, Main_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.InstrumentationHelper = void 0;
    var QueueNameSuffix = '-GiftCertificate';
    var ExtensionVersion = '1.2.5';
    var ComponentArea = 'SC Gift Certificate';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (environment) {
            Instrumentation_1.default.initialize({
                environment: environment,
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                },
            });
        };
        InstrumentationHelper.sendLogForDomainConfiguration = function () {
            InstrumentationHelper.sendLogForMyAccountEnablement();
            InstrumentationHelper.sendLogForShoppingEnablement();
            InstrumentationHelper.sendLogForGiftCertificatesGroupEnablement();
            InstrumentationHelper.sendLogForHideInventoryTypesFromFacetsEnablement();
            InstrumentationHelper.sendLogForShowImageOptionsSwatchEnablement();
        };
        InstrumentationHelper.sendLogForMyAccountEnablement = function () {
            var requestLog = Instrumentation_1.default.getLog('giftCertificateRequestLog');
            var message = Main_Configuration_1.MainConfiguration.enableGiftCertMyAccount
                ? 'Gift Certificate Management enabled on My Account'
                : 'Gift Certificate Management disabled on My Account';
            requestLog.setParameters({
                activity: message,
            });
            requestLog.submit();
        };
        InstrumentationHelper.sendLogForShoppingEnablement = function () {
            var requestLog = Instrumentation_1.default.getLog('giftCertificateRequestLog');
            var message = Main_Configuration_1.MainConfiguration.enableGiftCertShopping
                ? 'Gift Certificate Management enabled on Shopping'
                : 'Gift Certificate Management disabled on Shopping';
            requestLog.setParameters({
                activity: message,
            });
            requestLog.submit();
        };
        InstrumentationHelper.sendLogForGiftCertificatesGroupEnablement = function () {
            var requestLog = Instrumentation_1.default.getLog('giftCertificateRequestLog');
            var message = OptionTiles_Configuration_1.OptionTilesConfiguration.groupCertificatesAsItemOptions
                ? 'Gift Certificate groups enabled'
                : 'Gift Certificate groups disabled';
            requestLog.setParameters({
                activity: message,
            });
            requestLog.submit();
        };
        InstrumentationHelper.sendLogForHideInventoryTypesFromFacetsEnablement = function () {
            var requestLog = Instrumentation_1.default.getLog('hideInventoryTypesFromFacetsEnablementLog');
            var message = Main_Configuration_1.MainConfiguration.hideInventoryTypesFromFacets
                ? 'Hide Inventory Types from Facets enabled'
                : 'Hide Inventory Types from Facets disabled';
            requestLog.setParameters({
                activity: message,
            });
            requestLog.submit();
        };
        InstrumentationHelper.sendLogForShowImageOptionsSwatchEnablement = function () {
            var requestLog = Instrumentation_1.default.getLog('showImageOptionsSwatchSettingEnablement');
            var message = OptionTiles_Configuration_1.OptionTilesConfiguration.useThumbnailInButtonLabel
                ? 'Show image options swatch enabled'
                : 'Show image options swatch disabled';
            requestLog.setParameters({
                activity: message,
            });
            requestLog.submit();
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
